import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  section: {
    fontSize: 10,
    paddingLeft: 7,
    color: '#8c8c8c',
  },
  instructionText: {
    color: '#006080',
  },
});

export function VendorProjectMatrixSectionDescription() {
  const { section } = styles;

  return (
    <View style={section}>
      <Text>
        Allocate the percentage of vendor expense to the project(s). You must allocate 100% of each
        vendor expense for the survey to be considered complete. Alternatively, download this
        matrix, fill it offline, and upload back. Do not change the format of the downloaded file
      </Text>
    </View>
  );
}

export default VendorProjectMatrixSectionDescription;
